import { buildEvent } from "../EventMessageBuilder";

export const DEMO_ABOUT_TEXT =
  "Get the full version for Windows on [Steam](https://store.steampowered.com/app/2311680/Magic_Research/?utm_source=demo_about_web), for Android in [the Google Play Store](https://play.google.com/store/apps/details?id=com.mcolotto.magicresearchfull&utm_source=demo_about_web) or for iOS in [the App Store](https://apps.apple.com/app/magic-research/id1671272877)!";

const headmasterDefeatedDemoEventBuilder = buildEvent(
  "demo_finished",
  "Thanks for playing the Demo",
  [],
);

const headmasterDefeatedDemoEvent = headmasterDefeatedDemoEventBuilder
  .createMessage()
  .setSimpleDescription(
    `You have beaten the Ancient Headmaster! This is the end of the Demo of Magic Research. **Thank you for playing!**
  
In the full game, you can expect much more content: many new dungeons, new items and features, and countless new secrets... Your progress from the Demo can be easily transferred to the full game.

Are you talented enough to lead your school to win the Tournament of Magic?

**Get the full game now for Windows on [Steam](https://store.steampowered.com/app/2311680/Magic_Research/?utm_source=demo_end_web), for Android in [the Google Play Store](https://play.google.com/store/apps/details?id=com.mcolotto.magicresearchfull&utm_source=demo_end_web), or for iOS in the [App Store](https://apps.apple.com/app/id1671272877)!**`,
  )
  .build();

export { headmasterDefeatedDemoEvent };
